export const environment = {
  production: false,
  isDevelopment: true,
  apiBaseUrl: 'https://api.qa.circlek.com',
  googleApiKey: 'AIzaSyBmvXvDpOEj49l9mD7cLtdCb8rnnMRs_jg',
  sentryEnvironment: 'development',
  logSentryErrors: true,
  googleGtmId: 'GTM-W5C3C4S',
  fuelDayBaseUrl: 'https://store-locator-dev.stormap-test.alpaque.net',
};
